import React, { Fragment } from "react";
import CustomTable from "../templates/CustomTable";
import { eventHeader } from "../utils/HeaderData";
import { useNavigate } from "react-router-dom";
import { Add, Church } from "@mui/icons-material";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { useUser } from "../components/context/UserContext";

const Event = () => {
  const navigate = useNavigate();
  const { userRole } = useUser();
  const canManage = userRole !== "operator";
  const [events, setEvents] = React.useState([]);

  React.useEffect(() => {
    const fetchEvents = async () => {
      try {
        const q = query(collection(db, "events"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        setEvents(
          snap.docs.map((d) => ({
            _id: d.id,
            ...d.data(),
            eventdate: d.data().eventdate?.toDate() || new Date(),
            createdAt: d.data().createdAt?.toDate() || new Date(),
          }))
        );
      } catch (err) {
        console.error(err.message);
      }
    };
    fetchEvents();
  }, []);

  return (
    <Fragment>
      <div className="min-h-screen bg-[#f5f7fe] p-3 sm:p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#eef2ff] flex items-center justify-center flex-shrink-0">
                <Church style={{ color: "#000C66", fontSize: 20 }} />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-[#000C66] font-aref">Events</h1>
                <p className="text-gray-400 text-xs font-abel">Manage church events</p>
              </div>
            </div>
            {canManage && (
              <button
                onClick={() => navigate("/create-event")}
                className="flex items-center justify-center gap-2 bg-[#000C66] text-white px-5 py-2.5 rounded-xl hover:bg-blue-900 transition font-abel text-sm font-semibold w-full sm:w-auto"
              >
                <Add style={{ fontSize: 18 }} /> Add Event
              </button>
            )}
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <CustomTable
              headers={eventHeader}
              data={events}
              editPath={canManage ? "/update-event" : null}
              deletePath={canManage ? "/delete-event" : null}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Event;
